import baseAxiosPublic from './config/baseAxiosPublic';
import { jwtDecode } from "jwt-decode";
import { getRefreshToken } from "../helpers/authStorage";

const postAuthentication = async (usuario, senha) => {
    const payload = { usuario, senha };
    return baseAxiosPublic.post('/api/authentication', payload)
        .then(({ data }) => decodeToken(data));
};

const postAuthenticationToken = async (token) => {
    return baseAxiosPublic.post('/api/authentication-token', { token })
        .then(({ data }) => decodeToken(data));
};

const postRefreshToken = async () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken)
        throw new Error("Refresh token ausente");

    return baseAxiosPublic.post('/api/refresh-token', { refreshToken })
        .then(({ data }) => decodeToken(data));
};

const postLogout = async (refreshToken) => {
    const tokenToUse = refreshToken || getRefreshToken();
    if (!tokenToUse) return;
    try {
        await baseAxiosPublic.post('/api/logout', { refreshToken: tokenToUse });
    } catch { }
};

function decodeToken({
    jwt,
    refreshToken,
    nome,
    nomeIniciais,
    cpfCnpj,
    email,
    telefone,
    vendedores
}) {
    const decoded = jwtDecode(jwt);

    const {
        role,
        ManagerUsers,
        ManagerPayments,
        ManagerReintegracaoPropostas,
        ManagerLimites,
        ManagerMargemConsignado,
        ManagerIncomingMessages,
        ManagerReservaMargem } = decoded;

    const permissoes = {
        PermissoesUsuarios: ManagerUsers,
        PermissoesPagamentos: ManagerPayments,
        PermissoesReintegracaoPropostas: ManagerReintegracaoPropostas,
        PermissoesLimites: ManagerLimites,
        PermissoesMargemConsignado: ManagerMargemConsignado,
        PermissoesMensagens: ManagerIncomingMessages,
        PermissoesReservaMargemConsignado: ManagerReservaMargem,
    };

    const ehAdmin = role?.includes('ADMINISTRADOR') || ManagerUsers !== undefined;
    const ehVendedor = role?.includes('VENDEDOR');
    const ehFuncionarioUN = role?.includes('FUNCIONARIOUN');
    const { codigoCorretor } = vendedores?.find(x => x?.perfilPadrao) ?? {};
    const userApp = {
        ehAdmin,
        ehVendedor,
        ehFuncionarioUN,
        accessToken: jwt,
        refreshToken: refreshToken || null,
        nomeIniciais,
        nome,
        email,
        role,
        cpfCnpj,
        telefone,
        vendedores,
        codigoCorretor,
        permissoes
    };
    return { user: userApp };
}

export { postAuthentication, postAuthenticationToken, postRefreshToken, postLogout };